import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Importa aquí tu componente standalone
import { ServiceBadgeComponent } from './components/service-badge/service-badge.component';

@NgModule({
  declarations: [
    // Componentes antiguos (no standalone) van aquí
  ],
  imports: [
    CommonModule,
    ServiceBadgeComponent // Se importa porque es standalone
  ],
  exports: [
    ServiceBadgeComponent, // Se exporta para que otros lo usen
    CommonModule
  ]
})
export class SharedModule { }